document.addEventListener("DOMContentLoaded", function() {
  // Initial call to the function for displaying the image corresponding to the empty option
  let selects = document.querySelectorAll(".select_options");
  selects.forEach(function(selectElement) {
    checkNothingOption(selectElement);
  });
});

const checkNothingOption = (selectElement) => {
  let productIDInput = document.querySelector(".productIDInput");
  let productTextbox = document.getElementById("textBox")
  let isNothingSelected = selectElement.value === "nothing";
  let selectId = selectElement.id;

  /*
    Don't receive any info from the select to add multiple
    products if the option is of nothing value
  */
  if (isNothingSelected) {
    selectElement.name = "";
  } else {
    selectElement.name = "id[]";
  }

  // Update the image corresponding to the select
  let selectedImage = document.getElementById(`selectedImage${selectId.slice(-1)}`);

  let selectedOption = selectElement.options[selectElement.selectedIndex];
  let imageURL = selectedOption.getAttribute("data-image");
  selectedImage.src = imageURL;

  // Check all selects to set the input name
  let selects = document.querySelectorAll(".select_options");
  let isAnySelected = Array.from(selects).some((select) => select.value !== "");

  /*
    Modify the name of the input and textbox depending is the options are selected
    In this case the line item property only will be added to the main product
  */
  if (isAnySelected) {
    productIDInput.name = "items[0]id";
    productTextbox.name = "items[0]properties[Free Personalized Gift Message]";
  } else {
    productIDInput.name = "id";
    productTextbox.name = "properties[Free Personalized Gift Message]";
  }
}
